import { Box, type SxProps, type Theme } from '@mui/material';
import type React from 'react';

import { spaces } from '../../assets/styles/themes/tokens';
import useScreenSize from '../../utils/useScreenSize';

interface FormContainerProps {
	children?: React.ReactNode;
	innerContainerSx?: SxProps<Theme>;
	isLoginPage?: boolean;
}

const FormContainer: React.FC<FormContainerProps> = ({
	children,
	innerContainerSx,
	isLoginPage,
}) => {
	const { isXsScreen } = useScreenSize();
	const containerPadding = isLoginPage
		? {
				paddingTop: isXsScreen ? spaces.md : spaces.xxl,
				paddingBottom: spaces.md,
				paddingLeft: isXsScreen ? spaces.md : 0,
				paddingRight: isXsScreen ? spaces.md : 0,
			}
		: {
				padding: isXsScreen ? spaces.md : `${spaces.xxxxxl} 0`,
			};

	return (
		<Box
			data-testid="onboarding-page-form"
			sx={{
				display: 'flex',
				minWidth: isXsScreen ? 'auto' : 600,
				maxHeight: '100vh',
				overflowX: 'auto',
				flexDirection: 'column',
				alignItems: 'center',
				gap: spaces.xxxl,
				flex: '1 0 0',
				alignSelf: 'stretch',
				...containerPadding,
			}}
		>
			<Box
				sx={{
					display: 'flex',
					width: isXsScreen ? 'auto' : 600,
					maxWidth: '100%',
					flexDirection: 'column',
					gap: spaces.xxxl,
					flex: '1 0 0',
					...innerContainerSx,
				}}
			>
				{children}
			</Box>
		</Box>
	);
};

export default FormContainer;
